import React from "react";
import "./css/LoadingScreen2.css";
import { ReactComponent as Heart_SVG } from "../../assets/heart_logo_4.svg";

import LoadingSpinner2 from "./LoadingSpinner2";
import LoaderContainer from "./LoaderContainer";

function LoadingScreen2() {
  return (
    <LoaderContainer fullscreen style={{ backgroundColor: "var(--bg-main)" }}>
      <div className="loader-container">
        <Heart_SVG style={{ color: "var(--txt-3w)" }} />
        <LoadingSpinner2 size={1.55} color="var(--txt-4)" />
      </div>
    </LoaderContainer>
  );
}

export default LoadingScreen2;
